import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const getCurrentMonthAndYear = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so adding 1
  const currentYear = currentDate.getFullYear();

  return { month: currentMonth, Year: currentYear };
};

const initialState = {
  tourList: [],
  tourListLoaded: false,
  ...getCurrentMonthAndYear(),
  refresh: 0,
};

const fetchCalendlyEvents = async (month, year) => {
  let formatteddate = `${year}-${month
    .toString()
    .padStart(2, "0")}-01T00:00:00.000000Z`;

  const apiKey =
    "eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjY5ODc3MjY1LCJqdGkiOiI3ZGZmMDIyYy1jZDExLTRlYjctYjc1YS01MjNhMmM0NDI4ZTgiLCJ1c2VyX3V1aWQiOiJGQUhCT0E3NEdQV0RXT0lCIn0.NYMA7kmrvS0_8FvlxLySBZ610Mo8O66UVC7eMvaE-mfpkwXU-o1b4l2PjcBdgiQMFrL_9CquUpI00dzMc-Gefw"; // Use environment variable for API key
  const organizationUrl =
    "https://api.calendly.com/organizations/DGFGMF24FQV6ZLPS";

  try {
    let next_page = `https://api.calendly.com/scheduled_events?organization=${organizationUrl}&min_start_time=${formatteddate}`;

    const allEvents = [];

    while (next_page) {
      const response = await fetch(next_page, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });

      if (response.ok) {
        const data = await response.json();

        const eventsWithInvitees = await Promise.all(
          data.collection.map(async (event) => {
            const inviteesResponse = await fetch(`${event.uri}/invitees`, {
              headers: {
                Authorization: `Bearer ${apiKey}`,
              },
            });

            if (inviteesResponse.ok) {
              const inviteesData = await inviteesResponse.json();
              return { ...event, invitees: inviteesData.collection };
            } else {
              console.error(
                `Failed to fetch invitees for event ${event.uri}, status: ${inviteesResponse.status}`
              );
              return event;
            }
          })
        );

        allEvents.push(...eventsWithInvitees);
        next_page = data.pagination.next_page;
      } else {
        console.error("Failed to fetch Calendly events", response);
        break;
      }
    }
    return allEvents;
  } catch (error) {
    console.error("Error fetching Calendly events", error);
    throw error;
  }
};

export const getTourList = createAsyncThunk("getTourList", async (e) => {
  let data = await fetchCalendlyEvents(e.month, e.Year);
  if (data) {
    const filteredEvents = data.filter((event) => {
      const isMatchingEvent = event.calendar_event.email === e.EmailID;
      const hasMatchingInvitee = event.invitees.some(
        (invitee) => invitee.email === e.EmailID
      );

      return isMatchingEvent || hasMatchingInvitee;
    });
    return filteredEvents;
  }

  return data;
});

const tourSlice = createSlice({
  name: "tour",
  initialState: initialState,
  reducers: {
    onMonthChange: (state, data) => {
      state.month = data.payload;
      state.refresh = state.refresh + 1;
    },

    onYearChange: (state, data) => {

      state.Year = data.payload;
      state.refresh = state.refresh + 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTourList.pending, (state) => {
      state.tourListLoaded = false;
    });

    builder.addCase(getTourList.fulfilled, (state, data) => {
      state.tourListLoaded = true;
      state.tourList = data.payload;
    });

    builder.addCase(getTourList.rejected, (state) => {
      state.tourListLoaded = true;
      state.tourList = [];
    });
  },
});

export const { onMonthChange, onYearChange } = tourSlice.actions;

export default tourSlice.reducer;
